import { render } from "./App.vue?vue&type=template&id=fa1b2918"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fa1b2918&lang=css"

import exportComponent from "C:\\Users\\MichaelGranbäck\\vue\\clones\\build-a-bot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__